import React from 'react';
import Layout from '../../components/Layout';
import Sponsor from '../../components/Sponsor';
import { t, props } from 'tcomb-react';


@props({
  locale: t.Obj,
  doAcceptCookies: t.Func,
  doRefresh: t.Func,
  err: t.Obj
})
export default class UnexpectedError extends React.Component {

  getSponsor() {
    const options = {
      showTutorial: false
    };
    return (<Sponsor locale={this.props.locale} options={options} />);
  }


  doRefresh = (evt) => {
    evt.preventDefault();
    this.props.doRefresh();
  };

  render() {
    return (
      <Layout locale={this.props.locale} sponsor={this.getSponsor()} doAcceptCookies={this.props.doAcceptCookies}>
        <div id="unexpected_error">
          <h1>An unexpected error has occured :-(</h1>
          <h2>Please try again after a few moments: <a href="#" target="_self" onClick={this.doRefresh}>click here</a></h2>
          <p>If you continue to receive this page, please contact customer service at <a href="mailto:support@madai.com" target="_new">support@madai.com</a></p>
        </div>
      </Layout>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/user/route/UnexpectedError.js
 **/